import { getCurrentShareBaseUrl } from '../shopify/share-link.js'
import { webComponentProperties } from '../shopify/web-component-properties.js'
import { configuratorInterface } from '../systems/configurator-interface.js'

export default configuratorInterface.createCollectFrontendDataHandler(async ctx => {
  const { getWebComponentPropertyValue } = ctx

  return {
    customerTags: getWebComponentPropertyValue(webComponentProperties.customerTags) ?? [],
    shareBaseUrl: getCurrentShareBaseUrl(),
  }
})
